const STORAGE_KEY = 'labnet-theme';

/**
 * @returns {'light'|'dark'}
 */
function getPreferredTheme() {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'dark' || saved === 'light') {
        return saved;
    }

    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

/**
 * @param {'light'|'dark'} theme
 */
function setTheme(theme) {
    document.documentElement.setAttribute('data-bs-theme', theme);
    localStorage.setItem(STORAGE_KEY, theme);
    updateToggleButtons(theme);
    document.dispatchEvent(new CustomEvent('theme-changed', { detail: { theme } }));
}

function toggleTheme() {
    const current = document.documentElement.getAttribute('data-bs-theme') || getPreferredTheme();
    setTheme(current === 'dark' ? 'light' : 'dark');
}

/**
 * @param {'light'|'dark'} theme
 */
function updateToggleButtons(theme) {
    document.querySelectorAll('[data-theme-toggle]').forEach((button) => {
        const iconLight = button.querySelector('.theme-icon-light');
        const iconDark = button.querySelector('.theme-icon-dark');

        if (iconLight) {
            iconLight.classList.toggle('d-none', theme === 'dark');
        }

        if (iconDark) {
            iconDark.classList.toggle('d-none', theme !== 'dark');
        }

        const label = theme === 'dark'
            ? button.dataset.labelLight
            : button.dataset.labelDark;

        if (label) {
            button.setAttribute('title', label);
            button.setAttribute('aria-label', label);
            const visibleLabel = button.querySelector('.sidebar-app-theme-toggle__label');
            if (visibleLabel) {
                visibleLabel.textContent = label;
            }
        }
    });
}

function initThemeManager() {
    const currentTheme = document.documentElement.getAttribute('data-bs-theme') || getPreferredTheme();
    updateToggleButtons(currentTheme);

    document.querySelectorAll('[data-theme-toggle]').forEach((button) => {
        button.addEventListener('click', (event) => {
            event.preventDefault();
            toggleTheme();
        });
    });

    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (event) => {
        if (localStorage.getItem(STORAGE_KEY)) {
            return;
        }

        setTheme(event.matches ? 'dark' : 'light');
    });
}

module.exports = {
    STORAGE_KEY,
    getPreferredTheme,
    setTheme,
    toggleTheme,
    initThemeManager,
};
